import { Plain } from '../../constants/colors';
import type { MotifComponent, MotifComponentProps } from '../../motif';

/** NOTE: Tiles always have white background with black text. */
export const defaultTileVars: MotifComponentProps<MotifComponent.TILE> = {
  '--tile-background-color': Plain.WHITE,
  '--tile-foreground-color': Plain.BLACK,
} as const;
